import script from "./AI.vue?vue&type=script&setup=true&lang=js"
export * from "./AI.vue?vue&type=script&setup=true&lang=js"

import "./AI.vue?vue&type=style&index=0&id=8390df78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8390df78"]])

export default __exports__